import { render, staticRenderFns } from "./micoapp_register.vue?vue&type=template&id=1e6982a4"
import script from "./micoapp_register.vue?vue&type=script&lang=js"
export * from "./micoapp_register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports